import React from "react";
import { BarLoader } from "react-spinners";
import { assetsPrefix } from "../../utilities/utilities";

const LazyLoading = ({ message = "Loading your workspace..." }) => (
  <div className="fixed inset-0 z-[9999] flex items-center justify-center bg-gradient-to-br from-slate-50 via-white to-[#46BDE1]/5">
    <div
      className="flex w-full max-w-sm flex-col items-center rounded-2xl border border-slate-100 bg-white/90 px-10 py-12 shadow-[0_20px_60px_-24px_rgba(70,189,225,0.45)] backdrop-blur-sm"
      role="status"
      aria-live="polite"
      aria-label={message}
    >
      <div className="relative mb-8 flex h-24 w-24 items-center justify-center">
        <img
          src={`${assetsPrefix}/images/trueCounselLogo.png`}
          alt="TrueCounsel"
          className="relative h-20 max-w-40 object-contain"
        />
      </div>

      <BarLoader width={168} height={4} color="#46BDE1" aria-hidden="true" />

      <p className="mt-5 text-center text-sm font-medium tracking-wide text-slate-600">
        {message}
      </p>
      <p className="mt-1 text-center text-xs text-slate-400">
        Please wait a moment
      </p>
    </div>
  </div>
);

export default LazyLoading;
